import { UpdateProgressDto } from '../general/update-progress-dto';

export class UpdateFileDto extends UpdateProgressDto {
    public FileName: string;
    public FileType: string;
    public FileLocation: string;
    public UserAgreementApprovedDate: string;

    constructor(progress: number) {
        super(progress);
    }
}

export class UpdatePolicyFileDto extends UpdateProgressDto {
  public PolicyNameNl: string;
  public PolicyTypeNl: string;
  public PolicyLocationNl: string;
  public PolicyNameFr: string;
  public PolicyTypeFr: string;
  public PolicyLocationFr: string;
  public PolicyNameEn: string;
  public PolicyTypeEn: string;
  public PolicyLocationEn: string;

  constructor(progress: number) {
    super(progress);
  }
}
